import React from "react";
import { Check, ChevronDown } from "lucide-react";
import { LANGUAGES } from "../lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export function LanguageSelector({ lang, setLang, onDark = false }) {
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const triggerClass = onDark
    ? "inline-flex items-center gap-1.5 rounded-full border border-[#f7ebdf]/30 bg-[#f7ebdf]/10 backdrop-blur-sm px-3 py-1.5 text-sm font-medium text-[#f7ebdf] hover:bg-[#f7ebdf]/20 transition-colors shrink-0"
    : "inline-flex items-center gap-1.5 rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-sm font-medium text-neutral-700 hover:bg-neutral-50 transition-colors shrink-0";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={triggerClass}>
          <span className="text-xs font-semibold tracking-wide">{current.flag}</span>
          <ChevronDown className={`h-3.5 w-3.5 ${onDark ? "text-[#f7ebdf]/70" : "text-neutral-500"}`} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        sideOffset={6}
        className="w-44 z-[10000] shadow-2xl"
      >
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span>{l.label}</span>
            {l.code === lang && <Check className="h-4 w-4 text-[#4a1c17]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
